"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const es_1 = require("../../../backend/src/app/acl_module/config/i18n/es");
const es_2 = __importDefault(require("./landing/es"));
const onboarding_tooltip_1 = __importDefault(require("./es/onboarding_tooltip"));
const app_page_1 = __importDefault(require("./es/app_page"));
const app_intext_1 = __importDefault(require("./es/app_intext"));
const modal_share_1 = __importDefault(require("./es/modal_share"));
const modal_settings_1 = __importDefault(require("./es/modal_settings"));
const chat_entry_1 = __importDefault(require("./es/chat_entry"));
const slot_goal_1 = __importDefault(require("./es/slot_goal"));
const slot_target_1 = __importDefault(require("./es/slot_target"));
const slot_format_1 = __importDefault(require("./es/slot_format"));
const slotData_create_1 = __importDefault(require("./es/slotData_create"));
const slotData_load_1 = __importDefault(require("./es/slotData_load"));
const slotData_form_1 = __importDefault(require("./es/slotData_form"));
const slotData_type_1 = __importDefault(require("./es/slotData_type"));
const app_pagination_1 = __importDefault(require("./es/app_pagination"));
const payment_validation_1 = __importDefault(require("./es/payment_validation"));
const payment_status_1 = __importDefault(require("./es/payment_status"));
const payment_stripe_1 = __importDefault(require("./es/payment_stripe"));
const payment_provider_1 = __importDefault(require("./es/payment_provider"));
const payment_confirmed_1 = __importDefault(require("./es/payment_confirmed"));
const route_payment_1 = __importDefault(require("./es/route_payment"));
const payment_search_1 = __importDefault(require("./es/payment_search"));
const payment_preview_1 = __importDefault(require("./es/payment_preview"));
const user_roles_1 = __importDefault(require("./es/user_roles"));
const user_grade_1 = __importDefault(require("./es/user_grade"));
const userGroup_form_1 = __importDefault(require("./es/userGroup_form"));
const userGroup_error_1 = __importDefault(require("./es/userGroup_error"));
const user_form_1 = __importDefault(require("./es/user_form"));
const user_profile_1 = __importDefault(require("./es/user_profile"));
const route_userGroup_1 = __importDefault(require("./es/route_userGroup"));
const route_user_group_1 = __importDefault(require("./es/route_user_group"));
const company_preview_1 = __importDefault(require("./es/company_preview"));
const company_tooltips_1 = __importDefault(require("./es/company_tooltips"));
const company_form_1 = __importDefault(require("./es/company_form"));
const access_status_1 = __importDefault(require("./es/access_status"));
const access_list_1 = __importDefault(require("./es/access_list"));
const avatar_processing_1 = __importDefault(require("./es/avatar_processing"));
const avatar_form_1 = __importDefault(require("./es/avatar_form"));
const webhook_eventTypes_1 = __importDefault(require("./es/webhook_eventTypes"));
const webhook_cronIntervals_1 = __importDefault(require("./es/webhook_cronIntervals"));
const tools_imgGen_1 = __importDefault(require("./es/tools_imgGen"));
const tools_convoTags_1 = __importDefault(require("./es/tools_convoTags"));
const tools_galleryTags_1 = __importDefault(require("./es/tools_galleryTags"));
const tools_detectContactData_1 = __importDefault(require("./es/tools_detectContactData"));
const tools_detectTasks_1 = __importDefault(require("./es/tools_detectTasks"));
const tools_productCompare_1 = __importDefault(require("./es/tools_productCompare"));
const tools_askForVoucher_1 = __importDefault(require("./es/tools_askForVoucher"));
const tools_offerCreator_1 = __importDefault(require("./es/tools_offerCreator"));
const tools_quickOffer_1 = __importDefault(require("./es/tools_quickOffer"));
const tools_sendContactForm_1 = __importDefault(require("./es/tools_sendContactForm"));
const tools_apiTool_1 = __importDefault(require("./es/tools_apiTool"));
const tools_productAPISearch_1 = __importDefault(require("./es/tools_productAPISearch"));
const tools_dynamicListings_1 = __importDefault(require("./es/tools_dynamicListings"));
const tools_productCard_1 = __importDefault(require("./es/tools_productCard"));
const tools_personalData_1 = __importDefault(require("./es/tools_personalData"));
const tools_rag_1 = __importDefault(require("./es/tools_rag"));
const tools_aiFormAnalyzer_1 = __importDefault(require("./es/tools_aiFormAnalyzer"));
const tools_communications_search_1 = __importDefault(require("./es/tools_communications_search"));
const avatar_common_1 = __importDefault(require("./es/avatar_common"));
const avatar_active_1 = __importDefault(require("./es/avatar_active"));
const avatar_tooltips_1 = __importDefault(require("./es/avatar_tooltips"));
const avatar_knowledge_1 = __importDefault(require("./es/avatar_knowledge"));
const avatar_preview_1 = __importDefault(require("./es/avatar_preview"));
const style_form_1 = __importDefault(require("./es/style_form"));
const accountGrade_list_1 = __importDefault(require("./es/accountGrade_list"));
const accountGrade_form_1 = __importDefault(require("./es/accountGrade_form"));
const limits_avatar_1 = __importDefault(require("./es/limits_avatar"));
const limits_user_1 = __importDefault(require("./es/limits_user"));
const limits_project_1 = __importDefault(require("./es/limits_project"));
const limits_knowledge_1 = __importDefault(require("./es/limits_knowledge"));
const limits_bulk_1 = __importDefault(require("./es/limits_bulk"));
const limits_customModel_1 = __importDefault(require("./es/limits_customModel"));
const limits_writingStyles_1 = __importDefault(require("./es/limits_writingStyles"));
const limits_advanced_prompts_1 = __importDefault(require("./es/limits_advanced-prompts"));
const limits_prompt_assist_1 = __importDefault(require("./es/limits_prompt-assist"));
const limits_anti_hallucination_1 = __importDefault(require("./es/limits_anti-hallucination"));
const limits_advanced_reports_1 = __importDefault(require("./es/limits_advanced-reports"));
const limits_chat_thread_sharing_1 = __importDefault(require("./es/limits_chat-thread-sharing"));
const limits_custom_branding_1 = __importDefault(require("./es/limits_custom-branding"));
const limits_widgets_1 = __importDefault(require("./es/limits_widgets"));
const limits_voice_agent_1 = __importDefault(require("./es/limits_voice-agent"));
const limits_upgrade_1 = __importDefault(require("./es/limits_upgrade"));
const voice_chat_error_1 = __importDefault(require("./es/voice-chat_error"));
const email_pass_reset_1 = __importDefault(require("./es/email_pass_reset"));
const email_activation_1 = __importDefault(require("./es/email_activation"));
const email_upgrade_1 = __importDefault(require("./es/email_upgrade"));
const email_payment_1 = __importDefault(require("./es/email_payment"));
const register_complete_1 = __importDefault(require("./es/register_complete"));
const password_reset_1 = __importDefault(require("./es/password_reset"));
const accountGrade_preview_1 = __importDefault(require("./es/accountGrade_preview"));
const table_controls_1 = __importDefault(require("./es/table_controls"));
const route_settings_1 = __importDefault(require("./es/route_settings"));
const route_style_1 = __importDefault(require("./es/route_style"));
const route_company_1 = __importDefault(require("./es/route_company"));
const route_user_1 = __importDefault(require("./es/route_user"));
const route_accountGrade_1 = __importDefault(require("./es/route_accountGrade"));
const route_branch_1 = __importDefault(require("./es/route_branch"));
const route_profession_1 = __importDefault(require("./es/route_profession"));
const route_avatar_1 = __importDefault(require("./es/route_avatar"));
const route_conversation_1 = __importDefault(require("./es/route_conversation"));
const route_botTest_1 = __importDefault(require("./es/route_botTest"));
const route_tutorial_1 = __importDefault(require("./es/route_tutorial"));
const tutorial_create_1 = __importDefault(require("./es/tutorial_create"));
const tutorial_edit_1 = __importDefault(require("./es/tutorial_edit"));
const tutorial_preview_1 = __importDefault(require("./es/tutorial_preview"));
const tutorial_delete_1 = __importDefault(require("./es/tutorial_delete"));
const tutorial_list_1 = __importDefault(require("./es/tutorial_list"));
const tutorial_start_1 = __importDefault(require("./es/tutorial_start"));
const tutorial_new_section_1 = __importDefault(require("./es/tutorial_new-section"));
const tutorial_search_1 = __importDefault(require("./es/tutorial_search"));
const tutorial_form_1 = __importDefault(require("./es/tutorial_form"));
const tutorial_validation_1 = __importDefault(require("./es/tutorial_validation"));
const tutorial_todos_1 = __importDefault(require("./es/tutorial_todos"));
const tutorial_statistics_1 = __importDefault(require("./es/tutorial_statistics"));
const tutorial_errors_1 = __importDefault(require("./es/tutorial_errors"));
const botTest_create_1 = __importDefault(require("./es/botTest_create"));
const botTest_edit_1 = __importDefault(require("./es/botTest_edit"));
const botTest_tester_1 = __importDefault(require("./es/botTest_tester"));
const botTest_target_1 = __importDefault(require("./es/botTest_target"));
const botTest_list_1 = __importDefault(require("./es/botTest_list"));
const botTest_actions_1 = __importDefault(require("./es/botTest_actions"));
const botTest_preview_1 = __importDefault(require("./es/botTest_preview"));
const botTest_testResults_1 = __importDefault(require("./es/botTest_testResults"));
const route_ai_1 = __importDefault(require("./es/route_ai"));
const ai_models_1 = __importDefault(require("./es/ai_models"));
const ai_com_1 = __importDefault(require("./es/ai_com"));
const ai_fields_1 = __importDefault(require("./es/ai_fields"));
const ai_controls_1 = __importDefault(require("./es/ai_controls"));
const ai_assist_suggestions_1 = __importDefault(require("./es/ai-assist_suggestions"));
const knowledge_picker_1 = __importDefault(require("./es/knowledge_picker"));
const ai_suggestions_1 = __importDefault(require("./es/ai_suggestions"));
const autocomplete_triggers_1 = __importDefault(require("./es/autocomplete_triggers"));
const ai_assist_1 = __importDefault(require("./es/ai_assist"));
const conversation_type_1 = __importDefault(require("./es/conversation_type"));
const conversation_agent_1 = __importDefault(require("./es/conversation_agent"));
const conversation_session_1 = __importDefault(require("./es/conversation_session"));
const conversation_avatar_1 = __importDefault(require("./es/conversation_avatar"));
const conversation_voice_1 = __importDefault(require("./es/conversation_voice"));
const conversation_clear_1 = __importDefault(require("./es/conversation_clear"));
const conversation_auto_1 = __importDefault(require("./es/conversation_auto"));
const conversation_start_1 = __importDefault(require("./es/conversation_start"));
const conversation_stop_1 = __importDefault(require("./es/conversation_stop"));
const conversation_recording_1 = __importDefault(require("./es/conversation_recording"));
const recording_start_1 = __importDefault(require("./es/recording_start"));
const recording_process_1 = __importDefault(require("./es/recording_process"));
const conversation_end_1 = __importDefault(require("./es/conversation_end"));
const message_send_1 = __importDefault(require("./es/message_send"));
const microphone_access_1 = __importDefault(require("./es/microphone_access"));
const conversation_interruption_1 = __importDefault(require("./es/conversation_interruption"));
const conversations_search_1 = __importDefault(require("./es/conversations_search"));
const conversations_date_1 = __importDefault(require("./es/conversations_date"));
const conversations_error_1 = __importDefault(require("./es/conversations_error"));
const conversations_delete_1 = __importDefault(require("./es/conversations_delete"));
const conversations_favorite_1 = __importDefault(require("./es/conversations_favorite"));
const account_upgrade_1 = __importDefault(require("./es/account_upgrade"));
const account_grades_1 = __importDefault(require("./es/account_grades"));
const route_knowledge_1 = __importDefault(require("./es/route_knowledge"));
const route_knowledgeProject_1 = __importDefault(require("./es/route_knowledgeProject"));
const knowledge_title_1 = __importDefault(require("./es/knowledge_title"));
const knowledge_description_1 = __importDefault(require("./es/knowledge_description"));
const knowledge_content_1 = __importDefault(require("./es/knowledge_content"));
const knowledge_tags_1 = __importDefault(require("./es/knowledge_tags"));
const knowledge_active_1 = __importDefault(require("./es/knowledge_active"));
const knowledge_filter_1 = __importDefault(require("./es/knowledge_filter"));
const knowledge_native_1 = __importDefault(require("./es/knowledge_native"));
const knowledge_ragStatus_1 = __importDefault(require("./es/knowledge_ragStatus"));
const knowledge_statusInfo_1 = __importDefault(require("./es/knowledge_statusInfo"));
const knowledge_form_1 = __importDefault(require("./es/knowledge_form"));
const knowledge_bulk_upload_1 = __importDefault(require("./es/knowledge_bulk_upload"));
const knowledge_preview_1 = __importDefault(require("./es/knowledge_preview"));
const project_form_1 = __importDefault(require("./es/project_form"));
const project_name_1 = __importDefault(require("./es/project_name"));
const project_description_1 = __importDefault(require("./es/project_description"));
const project_icon_1 = __importDefault(require("./es/project_icon"));
const file_upload_1 = __importDefault(require("./es/file_upload"));
const file_clipboard_1 = __importDefault(require("./es/file_clipboard"));
const chat_teaser_1 = __importDefault(require("./es/chat_teaser"));
const chat_heading_1 = __importDefault(require("./es/chat_heading"));
const chat_page_1 = __importDefault(require("./es/chat_page"));
const chat_config_1 = __importDefault(require("./es/chat_config"));
const chat_noCredits_1 = __importDefault(require("./es/chat_noCredits"));
const trainer_reset_1 = __importDefault(require("./es/trainer_reset"));
const trainer_tab_1 = __importDefault(require("./es/trainer_tab"));
const trainer_upload_1 = __importDefault(require("./es/trainer_upload"));
const trainer_config_1 = __importDefault(require("./es/trainer_config"));
const trainer_progress_1 = __importDefault(require("./es/trainer_progress"));
const trainer_results_1 = __importDefault(require("./es/trainer_results"));
const trainer_instructions_1 = __importDefault(require("./es/trainer_instructions"));
const chat_sync_1 = __importDefault(require("./es/chat_sync"));
const ai_chat_1 = __importDefault(require("./es/ai_chat"));
const branch_list_1 = __importDefault(require("./es/branch_list"));
const branch_create_1 = __importDefault(require("./es/branch_create"));
const branch_edit_1 = __importDefault(require("./es/branch_edit"));
const branch_search_1 = __importDefault(require("./es/branch_search"));
const branch_delete_1 = __importDefault(require("./es/branch_delete"));
const branch_form_1 = __importDefault(require("./es/branch_form"));
const profession_list_1 = __importDefault(require("./es/profession_list"));
const profession_create_1 = __importDefault(require("./es/profession_create"));
const profession_edit_1 = __importDefault(require("./es/profession_edit"));
const profession_search_1 = __importDefault(require("./es/profession_search"));
const profession_delete_1 = __importDefault(require("./es/profession_delete"));
const profession_form_1 = __importDefault(require("./es/profession_form"));
const profession_common_1 = __importDefault(require("./es/profession_common"));
const step_shared_1 = __importDefault(require("./es/step_shared"));
const step_list_1 = __importDefault(require("./es/step_list"));
const step_create_1 = __importDefault(require("./es/step_create"));
const step_edit_1 = __importDefault(require("./es/step_edit"));
const step_search_1 = __importDefault(require("./es/step_search"));
const step_delete_1 = __importDefault(require("./es/step_delete"));
const step_form_1 = __importDefault(require("./es/step_form"));
const question_list_1 = __importDefault(require("./es/question_list"));
const question_create_1 = __importDefault(require("./es/question_create"));
const question_edit_1 = __importDefault(require("./es/question_edit"));
const question_search_1 = __importDefault(require("./es/question_search"));
const question_delete_1 = __importDefault(require("./es/question_delete"));
const question_form_1 = __importDefault(require("./es/question_form"));
const question_type_1 = __importDefault(require("./es/question_type"));
const onboarding_intro_1 = __importDefault(require("./es/onboarding_intro"));
const onboarding_list_1 = __importDefault(require("./es/onboarding_list"));
const onboarding_create_1 = __importDefault(require("./es/onboarding_create"));
const onboarding_edit_1 = __importDefault(require("./es/onboarding_edit"));
const onboarding_search_1 = __importDefault(require("./es/onboarding_search"));
const onboarding_delete_1 = __importDefault(require("./es/onboarding_delete"));
const onboarding_status_1 = __importDefault(require("./es/onboarding_status"));
const onboarding_wizard_1 = __importDefault(require("./es/onboarding_wizard"));
const onboarding_benefits_1 = __importDefault(require("./es/onboarding_benefits"));
const onboarding_button_1 = __importDefault(require("./es/onboarding_button"));
const onboarding_image_1 = __importDefault(require("./es/onboarding_image"));
const onboarding_faq_1 = __importDefault(require("./es/onboarding_faq"));
const onboarding_setup_1 = __importDefault(require("./es/onboarding_setup"));
const onboarding_knowledge_1 = __importDefault(require("./es/onboarding_knowledge"));
const onboarding_avatar_1 = __importDefault(require("./es/onboarding_avatar"));
const onboarding_profession_1 = __importDefault(require("./es/onboarding_profession"));
const voices_david_1 = __importDefault(require("./es/voices_david"));
const voices_bradford_1 = __importDefault(require("./es/voices_bradford"));
const voices_clyde_1 = __importDefault(require("./es/voices_clyde"));
const voices_natalie_1 = __importDefault(require("./es/voices_natalie"));
const voices_jane_1 = __importDefault(require("./es/voices_jane"));
const voices_magdalena_1 = __importDefault(require("./es/voices_magdalena"));
const onboarding_records_1 = __importDefault(require("./es/onboarding_records"));
const onboarding_record_1 = __importDefault(require("./es/onboarding_record"));
const onboarding_warning_1 = __importDefault(require("./es/onboarding_warning"));
const onboarding_step_1 = __importDefault(require("./es/onboarding_step"));
const onboarding_questions_1 = __importDefault(require("./es/onboarding_questions"));
const onboarding_pagination_1 = __importDefault(require("./es/onboarding_pagination"));
const onboarding_progress_1 = __importDefault(require("./es/onboarding_progress"));
const onboarding_stats_1 = __importDefault(require("./es/onboarding_stats"));
const onboarding_view_1 = __importDefault(require("./es/onboarding_view"));
const onboarding_pick_1 = __importDefault(require("./es/onboarding_pick"));
const onboarding_error_1 = __importDefault(require("./es/onboarding_error"));
const onboarding_success_1 = __importDefault(require("./es/onboarding_success"));
const onboarding_notify_1 = __importDefault(require("./es/onboarding_notify"));
const login_username_1 = __importDefault(require("./es/login_username"));
const login_password_1 = __importDefault(require("./es/login_password"));
const login_form_1 = __importDefault(require("./es/login_form"));
const register_name_1 = __importDefault(require("./es/register_name"));
const register_username_1 = __importDefault(require("./es/register_username"));
const register_email_1 = __importDefault(require("./es/register_email"));
const register_password_1 = __importDefault(require("./es/register_password"));
const register_repeat_password_1 = __importDefault(require("./es/register_repeat_password"));
const register_form_1 = __importDefault(require("./es/register_form"));
const register_company_1 = __importDefault(require("./es/register_company"));
const activate_hero_1 = __importDefault(require("./es/activate_hero"));
const activate_page_1 = __importDefault(require("./es/activate_page"));
const activate_loading_1 = __importDefault(require("./es/activate_loading"));
const activate_success_1 = __importDefault(require("./es/activate_success"));
const activate_error_1 = __importDefault(require("./es/activate_error"));
const activate_button_1 = __importDefault(require("./es/activate_button"));
const settings_general_1 = __importDefault(require("./es/settings_general"));
const settings_socialMedia_1 = __importDefault(require("./es/settings_socialMedia"));
const settings_status_1 = __importDefault(require("./es/settings_status"));
const settings_rag_1 = __importDefault(require("./es/settings_rag"));
const rag_settings_1 = __importDefault(require("./es/rag_settings"));
const settings_credit_1 = __importDefault(require("./es/settings_credit"));
const rag_file_1 = __importDefault(require("./es/rag_file"));
const settings_googleDrive_1 = __importDefault(require("./es/settings_googleDrive"));
const googleDrive_picker_1 = __importDefault(require("./es/googleDrive_picker"));
const route_reports_1 = __importDefault(require("./es/route_reports"));
const reports_access_1 = __importDefault(require("./es/reports_access"));
const reports_costReports_1 = __importDefault(require("./es/reports_costReports"));
const reports_export_1 = __importDefault(require("./es/reports_export"));
const reports_period_1 = __importDefault(require("./es/reports_period"));
const chat_settings_1 = __importDefault(require("./es/chat_settings"));
const config_tooltips_1 = __importDefault(require("./es/config_tooltips"));
const share_conversation_1 = __importDefault(require("./es/share_conversation"));
const reports_shared_1 = __importDefault(require("./es/reports_shared"));
const acl_table_1 = __importDefault(require("./es/acl_table"));
const shortcuts_button_1 = __importDefault(require("./es/shortcuts_button"));
const shortcuts_table_1 = __importDefault(require("./es/shortcuts_table"));
const shortcuts_knowledge_1 = __importDefault(require("./es/shortcuts_knowledge"));
const shortcuts_new_1 = __importDefault(require("./es/shortcuts_new"));
const shortcuts_settings_1 = __importDefault(require("./es/shortcuts_settings"));
const shortcuts_find_1 = __importDefault(require("./es/shortcuts_find"));
const shortcuts_prompt_1 = __importDefault(require("./es/shortcuts_prompt"));
const currency_error_1 = __importDefault(require("./es/currency_error"));
const nav_avatar_1 = __importDefault(require("./es/nav_avatar"));
const nav_model_1 = __importDefault(require("./es/nav_model"));
const nav_ai_1 = __importDefault(require("./es/nav_ai"));
const googleDrive_directoryPicker_1 = __importDefault(require("./es/googleDrive_directoryPicker"));
const knowledge_bulkUpload_1 = __importDefault(require("./es/knowledge_bulkUpload"));
const dblogs_filter_1 = __importDefault(require("./es/dblogs_filter"));
const dblogs_results_1 = __importDefault(require("./es/dblogs_results"));
const dblogs_col_1 = __importDefault(require("./es/dblogs_col"));
const dblogs_error_1 = __importDefault(require("./es/dblogs_error"));
const dblogs_search_1 = __importDefault(require("./es/dblogs_search"));
const dblogs_page_1 = __importDefault(require("./es/dblogs_page"));
const route_dblogs_1 = __importDefault(require("./es/route_dblogs"));
const db_operation_1 = __importDefault(require("./es/db_operation"));
const socialMediaPlan_wip_1 = __importDefault(require("./es/socialMediaPlan_wip"));
const socialMediaPlan_nav_1 = __importDefault(require("./es/socialMediaPlan_nav"));
const socialMediaPlan_dashboard_1 = __importDefault(require("./es/socialMediaPlan_dashboard"));
const socialMediaPlan_stat_1 = __importDefault(require("./es/socialMediaPlan_stat"));
const socialMediaPlan_tab_1 = __importDefault(require("./es/socialMediaPlan_tab"));
const socialMediaPlan_history_1 = __importDefault(require("./es/socialMediaPlan_history"));
const socialMediaPlan_library_1 = __importDefault(require("./es/socialMediaPlan_library"));
const socialMediaPlan_filter_1 = __importDefault(require("./es/socialMediaPlan_filter"));
const socialMediaPlan_drawer_1 = __importDefault(require("./es/socialMediaPlan_drawer"));
const socialMediaPlan_post_1 = __importDefault(require("./es/socialMediaPlan_post"));
const socialMediaPlan_approvalQueue_1 = __importDefault(require("./es/socialMediaPlan_approvalQueue"));
const socialMediaPlan_ai_1 = __importDefault(require("./es/socialMediaPlan_ai"));
const socialMediaPlan_channels_1 = __importDefault(require("./es/socialMediaPlan_channels"));
const socialMediaPlan_analytics_1 = __importDefault(require("./es/socialMediaPlan_analytics"));
const socialMediaPlan_creator_1 = __importDefault(require("./es/socialMediaPlan_creator"));
const socialMediaPlan_brief_1 = __importDefault(require("./es/socialMediaPlan_brief"));
const socialMediaPlan_schedule_1 = __importDefault(require("./es/socialMediaPlan_schedule"));
const socialMediaPlan_step_1 = __importDefault(require("./es/socialMediaPlan_step"));
const whatsapp_settingsList_1 = __importDefault(require("./es/whatsapp_settingsList"));
const whatsapp_settingsForm_1 = __importDefault(require("./es/whatsapp_settingsForm"));
const whatsapp_settings_1 = __importDefault(require("./es/whatsapp_settings"));
const whatsapp_groups_1 = __importDefault(require("./es/whatsapp_groups"));
const whatsapp_commsType_1 = __importDefault(require("./es/whatsapp_commsType"));
const whatsapp_sourceType_1 = __importDefault(require("./es/whatsapp_sourceType"));
const whatsapp_trackLog_1 = __importDefault(require("./es/whatsapp_trackLog"));
const whatsapp_dm_1 = __importDefault(require("./es/whatsapp_dm"));
const whatsapp_dashboard_1 = __importDefault(require("./es/whatsapp_dashboard"));
const activities_panel_1 = __importDefault(require("./es/activities_panel"));
const whatsapp_groupForm_1 = __importDefault(require("./es/whatsapp_groupForm"));
const route_whatsapp_1 = __importDefault(require("./es/route_whatsapp"));
const whatsapp_tabs_1 = __importDefault(require("./es/whatsapp_tabs"));
const whatsapp_threads_1 = __importDefault(require("./es/whatsapp_threads"));
const whatsapp_email_1 = __importDefault(require("./es/whatsapp_email"));
const whatsapp_directMessages_1 = __importDefault(require("./es/whatsapp_directMessages"));
exports.default = {
    ...onboarding_tooltip_1.default,
    ...app_page_1.default,
    ...app_intext_1.default,
    ...modal_share_1.default,
    ...modal_settings_1.default,
    ...chat_entry_1.default,
    ...slot_goal_1.default,
    ...slot_target_1.default,
    ...slot_format_1.default,
    ...slotData_create_1.default,
    ...slotData_load_1.default,
    ...slotData_form_1.default,
    ...slotData_type_1.default,
    ...app_pagination_1.default,
    ...payment_validation_1.default,
    ...payment_status_1.default,
    ...payment_stripe_1.default,
    ...payment_provider_1.default,
    ...payment_confirmed_1.default,
    ...route_payment_1.default,
    ...payment_search_1.default,
    ...payment_preview_1.default,
    ...user_roles_1.default,
    ...user_grade_1.default,
    ...userGroup_form_1.default,
    ...userGroup_error_1.default,
    ...user_form_1.default,
    ...user_profile_1.default,
    ...route_userGroup_1.default,
    ...route_user_group_1.default,
    ...company_preview_1.default,
    ...company_tooltips_1.default,
    ...company_form_1.default,
    ...access_status_1.default,
    ...access_list_1.default,
    ...avatar_processing_1.default,
    ...avatar_form_1.default,
    ...webhook_eventTypes_1.default,
    ...webhook_cronIntervals_1.default,
    ...tools_imgGen_1.default,
    ...tools_convoTags_1.default,
    ...tools_galleryTags_1.default,
    ...tools_detectContactData_1.default,
    ...tools_detectTasks_1.default,
    ...tools_productCompare_1.default,
    ...tools_askForVoucher_1.default,
    ...tools_offerCreator_1.default,
    ...tools_quickOffer_1.default,
    ...tools_sendContactForm_1.default,
    ...tools_apiTool_1.default,
    ...tools_productAPISearch_1.default,
    ...tools_dynamicListings_1.default,
    ...tools_productCard_1.default,
    ...tools_personalData_1.default,
    ...tools_rag_1.default,
    ...tools_aiFormAnalyzer_1.default,
    ...tools_communications_search_1.default,
    ...avatar_common_1.default,
    ...avatar_active_1.default,
    ...avatar_tooltips_1.default,
    ...avatar_knowledge_1.default,
    ...avatar_preview_1.default,
    ...style_form_1.default,
    ...accountGrade_list_1.default,
    ...accountGrade_form_1.default,
    ...limits_avatar_1.default,
    ...limits_user_1.default,
    ...limits_project_1.default,
    ...limits_knowledge_1.default,
    ...limits_bulk_1.default,
    ...limits_customModel_1.default,
    ...limits_writingStyles_1.default,
    ...limits_advanced_prompts_1.default,
    ...limits_prompt_assist_1.default,
    ...limits_anti_hallucination_1.default,
    ...limits_advanced_reports_1.default,
    ...limits_chat_thread_sharing_1.default,
    ...limits_custom_branding_1.default,
    ...limits_widgets_1.default,
    ...limits_voice_agent_1.default,
    ...limits_upgrade_1.default,
    ...voice_chat_error_1.default,
    ...email_pass_reset_1.default,
    ...email_activation_1.default,
    ...email_upgrade_1.default,
    ...email_payment_1.default,
    ...register_complete_1.default,
    ...password_reset_1.default,
    ...accountGrade_preview_1.default,
    ...table_controls_1.default,
    ...route_settings_1.default,
    ...route_style_1.default,
    ...route_company_1.default,
    ...route_user_1.default,
    ...route_accountGrade_1.default,
    ...route_branch_1.default,
    ...route_profession_1.default,
    ...route_avatar_1.default,
    ...route_conversation_1.default,
    ...route_botTest_1.default,
    ...route_tutorial_1.default,
    ...tutorial_create_1.default,
    ...tutorial_edit_1.default,
    ...tutorial_preview_1.default,
    ...tutorial_delete_1.default,
    ...tutorial_list_1.default,
    ...tutorial_start_1.default,
    ...tutorial_new_section_1.default,
    ...tutorial_search_1.default,
    ...tutorial_form_1.default,
    ...tutorial_validation_1.default,
    ...tutorial_todos_1.default,
    ...tutorial_statistics_1.default,
    ...tutorial_errors_1.default,
    ...botTest_create_1.default,
    ...botTest_edit_1.default,
    ...botTest_tester_1.default,
    ...botTest_target_1.default,
    ...botTest_list_1.default,
    ...botTest_actions_1.default,
    ...botTest_preview_1.default,
    ...botTest_testResults_1.default,
    ...route_ai_1.default,
    ...ai_models_1.default,
    ...ai_com_1.default,
    ...ai_fields_1.default,
    ...ai_controls_1.default,
    ...ai_assist_suggestions_1.default,
    ...knowledge_picker_1.default,
    ...ai_suggestions_1.default,
    ...autocomplete_triggers_1.default,
    ...ai_assist_1.default,
    ...conversation_type_1.default,
    ...conversation_agent_1.default,
    ...conversation_session_1.default,
    ...conversation_avatar_1.default,
    ...conversation_voice_1.default,
    ...conversation_clear_1.default,
    ...conversation_auto_1.default,
    ...conversation_start_1.default,
    ...conversation_stop_1.default,
    ...conversation_recording_1.default,
    ...recording_start_1.default,
    ...recording_process_1.default,
    ...conversation_end_1.default,
    ...message_send_1.default,
    ...microphone_access_1.default,
    ...conversation_interruption_1.default,
    ...conversations_search_1.default,
    ...conversations_date_1.default,
    ...conversations_error_1.default,
    ...conversations_delete_1.default,
    ...conversations_favorite_1.default,
    ...account_upgrade_1.default,
    ...account_grades_1.default,
    ...route_knowledge_1.default,
    ...route_knowledgeProject_1.default,
    ...knowledge_title_1.default,
    ...knowledge_description_1.default,
    ...knowledge_content_1.default,
    ...knowledge_tags_1.default,
    ...knowledge_active_1.default,
    ...knowledge_filter_1.default,
    ...knowledge_native_1.default,
    ...knowledge_ragStatus_1.default,
    ...knowledge_statusInfo_1.default,
    ...knowledge_form_1.default,
    ...knowledge_bulk_upload_1.default,
    ...knowledge_preview_1.default,
    ...project_form_1.default,
    ...project_name_1.default,
    ...project_description_1.default,
    ...project_icon_1.default,
    ...file_upload_1.default,
    ...file_clipboard_1.default,
    ...chat_teaser_1.default,
    ...chat_heading_1.default,
    ...chat_page_1.default,
    ...chat_config_1.default,
    ...chat_noCredits_1.default,
    ...trainer_reset_1.default,
    ...trainer_tab_1.default,
    ...trainer_upload_1.default,
    ...trainer_config_1.default,
    ...trainer_progress_1.default,
    ...trainer_results_1.default,
    ...trainer_instructions_1.default,
    ...chat_sync_1.default,
    ...ai_chat_1.default,
    ...branch_list_1.default,
    ...branch_create_1.default,
    ...branch_edit_1.default,
    ...branch_search_1.default,
    ...branch_delete_1.default,
    ...branch_form_1.default,
    ...profession_list_1.default,
    ...profession_create_1.default,
    ...profession_edit_1.default,
    ...profession_search_1.default,
    ...profession_delete_1.default,
    ...profession_form_1.default,
    ...profession_common_1.default,
    ...step_shared_1.default,
    ...step_list_1.default,
    ...step_create_1.default,
    ...step_edit_1.default,
    ...step_search_1.default,
    ...step_delete_1.default,
    ...step_form_1.default,
    ...question_list_1.default,
    ...question_create_1.default,
    ...question_edit_1.default,
    ...question_search_1.default,
    ...question_delete_1.default,
    ...question_form_1.default,
    ...question_type_1.default,
    ...onboarding_intro_1.default,
    ...onboarding_list_1.default,
    ...onboarding_create_1.default,
    ...onboarding_edit_1.default,
    ...onboarding_search_1.default,
    ...onboarding_delete_1.default,
    ...onboarding_status_1.default,
    ...onboarding_wizard_1.default,
    ...onboarding_benefits_1.default,
    ...onboarding_button_1.default,
    ...onboarding_image_1.default,
    ...onboarding_faq_1.default,
    ...onboarding_setup_1.default,
    ...onboarding_knowledge_1.default,
    ...onboarding_avatar_1.default,
    ...onboarding_profession_1.default,
    ...voices_david_1.default,
    ...voices_bradford_1.default,
    ...voices_clyde_1.default,
    ...voices_natalie_1.default,
    ...voices_jane_1.default,
    ...voices_magdalena_1.default,
    ...onboarding_records_1.default,
    ...onboarding_record_1.default,
    ...onboarding_warning_1.default,
    ...onboarding_step_1.default,
    ...onboarding_questions_1.default,
    ...onboarding_pagination_1.default,
    ...onboarding_progress_1.default,
    ...onboarding_stats_1.default,
    ...onboarding_view_1.default,
    ...onboarding_pick_1.default,
    ...onboarding_error_1.default,
    ...onboarding_success_1.default,
    ...onboarding_notify_1.default,
    ...login_username_1.default,
    ...login_password_1.default,
    ...login_form_1.default,
    ...register_name_1.default,
    ...register_username_1.default,
    ...register_email_1.default,
    ...register_password_1.default,
    ...register_repeat_password_1.default,
    ...register_form_1.default,
    ...register_company_1.default,
    ...activate_hero_1.default,
    ...activate_page_1.default,
    ...activate_loading_1.default,
    ...activate_success_1.default,
    ...activate_error_1.default,
    ...activate_button_1.default,
    ...settings_general_1.default,
    ...settings_socialMedia_1.default,
    ...settings_status_1.default,
    ...settings_rag_1.default,
    ...rag_settings_1.default,
    ...settings_credit_1.default,
    ...rag_file_1.default,
    ...settings_googleDrive_1.default,
    ...googleDrive_picker_1.default,
    ...route_reports_1.default,
    ...reports_access_1.default,
    ...reports_costReports_1.default,
    ...reports_export_1.default,
    ...reports_period_1.default,
    ...chat_settings_1.default,
    ...config_tooltips_1.default,
    ...share_conversation_1.default,
    ...reports_shared_1.default,
    ...acl_table_1.default,
    ...shortcuts_button_1.default,
    ...shortcuts_table_1.default,
    ...shortcuts_knowledge_1.default,
    ...shortcuts_new_1.default,
    ...shortcuts_settings_1.default,
    ...shortcuts_find_1.default,
    ...shortcuts_prompt_1.default,
    ...currency_error_1.default,
    ...nav_avatar_1.default,
    ...nav_model_1.default,
    ...nav_ai_1.default,
    ...googleDrive_directoryPicker_1.default,
    ...knowledge_bulkUpload_1.default,
    ...dblogs_filter_1.default,
    ...dblogs_results_1.default,
    ...dblogs_col_1.default,
    ...dblogs_error_1.default,
    ...dblogs_search_1.default,
    ...dblogs_page_1.default,
    ...route_dblogs_1.default,
    ...db_operation_1.default,
    ...socialMediaPlan_wip_1.default,
    ...socialMediaPlan_nav_1.default,
    ...socialMediaPlan_dashboard_1.default,
    ...socialMediaPlan_stat_1.default,
    ...socialMediaPlan_tab_1.default,
    ...socialMediaPlan_history_1.default,
    ...socialMediaPlan_library_1.default,
    ...socialMediaPlan_filter_1.default,
    ...socialMediaPlan_drawer_1.default,
    ...socialMediaPlan_post_1.default,
    ...socialMediaPlan_approvalQueue_1.default,
    ...socialMediaPlan_ai_1.default,
    ...socialMediaPlan_channels_1.default,
    ...socialMediaPlan_analytics_1.default,
    ...socialMediaPlan_creator_1.default,
    ...socialMediaPlan_brief_1.default,
    ...socialMediaPlan_schedule_1.default,
    ...socialMediaPlan_step_1.default,
    ...whatsapp_settingsList_1.default,
    ...whatsapp_settingsForm_1.default,
    ...whatsapp_settings_1.default,
    ...whatsapp_groups_1.default,
    ...whatsapp_commsType_1.default,
    ...whatsapp_sourceType_1.default,
    ...whatsapp_trackLog_1.default,
    ...whatsapp_dm_1.default,
    ...whatsapp_dashboard_1.default,
    ...activities_panel_1.default,
    ...whatsapp_groupForm_1.default,
    ...route_whatsapp_1.default,
    ...whatsapp_tabs_1.default,
    ...whatsapp_threads_1.default,
    ...whatsapp_email_1.default,
    ...whatsapp_directMessages_1.default,
    ...es_2.default,
    'app.name': "IntHub",
    'acl_resource.knowledge_group': 'Grupo de Conocimiento',
    'acl_resource.payment': 'Pago',
    'acl_resource.botTest': 'Prueba de Bot',
    'app.removed': 'Eliminado',
    'app.share': 'Compartir',
    'app.share_link': 'Compartir enlace',
    'app.co_share': 'Compartir con usuarios',
    // Modal headers
    // Chat
    'profile': 'Perfil',
    'messages': 'Mensajes',
    'logout': 'Cerrar sesión',
    'lang.en': 'Inglés',
    'lang.de': 'Alemán',
    'lang.es': 'Español',
    'lang.it': 'Italiano',
    'lang.pl': 'Polaco',
    'lang.zh': 'Chino',
    // User form language fields
    'slot.none': 'Ninguno',
    // Slot placeholders
    'slot.prompt_context': 'Tema',
    'slot.conversation_goal': 'Objetivo de conversación',
    'slot.conversation_target': 'Audiencia objetivo',
    'slot.conversation_format': 'Formato de salida',
    // Slot data management
    'slot-data.created': 'Datos de ranura creados exitosamente',
    'slot-data.deleted': 'Datos de ranura eliminados exitosamente',
    'pagination.itemsPerPage': 'Elementos por página',
    'pagination.ellipsis': '…',
    'search.placeholder': 'Buscar...',
    'search.clear': 'Limpiar búsqueda',
    'crud.create': 'Crear',
    'crud.edit': 'Editar',
    'crud.delete': 'Eliminar',
    'crud.preview': 'Vista previa',
    'crud.saving': 'Guardando...',
    'crud.filtering': 'Filtrado',
    'crud.searchPlaceholder': 'Buscar...',
    'crud.noCompanies': 'No se encontraron empresas',
    'crud.noEntries': 'No se encontraron entradas',
    'crud.failedToLoad': 'No se pudieron cargar los datos',
    'crud.confirmDelete': '¿Estás seguro de que deseas eliminar',
    'crud.deletedSuccessfully': 'Eliminado con éxito',
    'crud.failedToDelete': 'No se pudo eliminar',
    'crud.cantEditItem': 'Este elemento no se puede editar',
    'crud.cantDeleteItem': 'Este elemento no se puede eliminar',
    // Form operations
    'form.back': 'Atrás',
    // Common status terms
    'common.yes': 'Sí',
    'common.no': 'No',
    'common.active': 'Activo',
    'common.inactive': 'Inactivo',
    'common.common': 'Común',
    'common.ordering': 'Ordenación',
    'common.createdAt': 'Creado En',
    // Payment
    'payment.gateway': 'Pasarela de Pagos',
    'payment.provider': 'Proveedor de Pagos',
    'payment.amount': 'Cantidad',
    'payment.description': 'Descripción',
    'payment.sessionId': 'ID de Sesión',
    'payment.id': 'ID de Pago',
    'payment.status': 'Estado del Pago',
    'payment.currentStatus': 'Estado Actual',
    'payment.initiate': 'Iniciar Pago',
    'payment.testConnection': 'Probar Conexión',
    'payment.refreshStatus': 'Actualizar Estado',
    'payment.reset': 'Reiniciar Pago',
    'payment.defaultDescription': 'Transacción de pago',
    'payment.initialized': 'Pago inicializado exitosamente',
    'payment.initializationFailed': 'Falló la inicialización del pago',
    'payment.successful': 'Pago completado exitosamente',
    'payment.pending': 'Pago pendiente',
    'payment.rejected': 'Pago rechazado',
    'payment.error': 'Ocurrió un error en el pago',
    'payment.connectionSuccessful': 'Conexión al proveedor de pagos exitosa',
    'payment.connectionFailed': 'Falló la conexión al proveedor de pagos',
    'payment.statusCheckFailed': 'Falló la verificación del estado del pago',
    'payment.noPaymentId': 'No hay ID de pago disponible',
    'payment.processing': 'Procesando...',
    'payment.confirmationFailed': 'Confirmación de pago fallida',
    'payment.unsupportedProvider': 'Proveedor de pago no soportado',
    'payment.selectProvider': 'Seleccionar Proveedor de Pago',
    'payment.operationName': 'Operación de Pago',
    // Payment List & Preview
    'payment.user': 'Usuario',
    'payment.email': 'Correo Electrónico',
    'payment.targetGrade': 'Grado Objetivo',
    'payment.paidAt': 'Pagado El',
    'payment.failureReason': 'Razón del Fallo',
    'payment.details': 'Detalles del Pago',
    'payment.timeline': 'Cronología',
    'payment.created': 'Creado',
    'payment.updated': 'Actualizado',
    'payment.technicalDetails': 'Detalles Técnicos',
    'payment.stripePaymentIntentId': 'ID de Intención de Pago de Stripe',
    'payment.stripeCustomerId': 'ID de Cliente de Stripe',
    'payment.orderId': 'ID de Pedido',
    'payment.metadata': 'Metadatos',
    // Gender
    'gender.male': 'Masculino',
    'gender.female': 'Femenino',
    'searchUser.users': 'Usuarios',
    'searchUser.searchPlaceholder': 'Buscar usuarios...',
    'searchUser.selectedParticipants': 'Participantes seleccionados',
    'searchUser.availableUsers': 'Usuarios disponibles',
    'searchUser.noUsersFound': 'No se encontraron usuarios.',
    'searchUser.failedToLoadUsers': 'No se pudieron cargar los usuarios',
    'user.name': 'Nombre',
    'user.last_name': 'Apellido',
    'user.username': 'Nombre de usuario',
    'user.email': 'Correo electrónico',
    'user.parent': 'Usuario principal',
    'user.role': 'Rol',
    'user.status': 'Estado',
    'user.company': 'Empresa',
    'user.listTitle': 'Usuarios',
    'user.addUser': 'Agregar usuario',
    'user.searchPlaceholder': 'Buscar usuarios...',
    // User list component (for non-admin users)
    'userList.title': 'Miembros del Equipo',
    'userList.description': 'Conecta y colabora con los miembros de tu equipo',
    'userList.searchPlaceholder': 'Buscar miembros del equipo...',
    'userList.noUsers': 'No se encontraron miembros del equipo',
    'userList.loading': 'Cargando miembros del equipo...',
    'userList.online': 'En línea',
    'userList.offline': 'Desconectado',
    'userList.lastSeen': 'Visto por última vez',
    'userList.startChat': 'Iniciar Chat',
    'userList.viewProfile': 'Ver Perfil',
    // User Group List Columns
    'userGroup.name': 'Nombre',
    'userGroup.description': 'Descripción',
    'userGroup.active': 'Activo',
    'userGroup.owner': 'Propietario',
    'userGroup.userCount': 'Cantidad de Usuarios',
    // User Group list page
    'userGroup.listTitle': 'Grupos de Usuarios',
    'userGroup.addUserGroup': 'Agregar Grupo de Usuarios',
    'userGroup.searchPlaceholder': 'Buscar grupos de usuarios...',
    // User Group form page
    'userGroup.create': 'Crear Grupo de Usuarios',
    // User form
    // User form preview
    // User form errors
    // User profile
    // Routes
    'company.name': 'Nombre',
    'company.nip': 'NIF',
    'company.email': 'Correo electrónico',
    'company.phone': 'Teléfono',
    'company.city': 'Ciudad',
    'company.address': 'Dirección',
    'company.street': 'Calle',
    'company.postalCode': 'Código Postal',
    'company.website': 'Sitio Web',
    'company.description': 'Descripción',
    'company.modules': 'Módulos',
    'company.active': 'Activa',
    // Company Preview & Tooltips
    // Company form
    'access.user_or_company': 'Usuario / Empresa',
    'access.user_group': 'Grupo de Usuario',
    'access.policies': 'Políticas de acceso',
    'access.active': 'Activo',
    'avatar.image': 'Imagen',
    'avatar.name': 'Nombre',
    'avatar.gender': 'Género',
    'avatar.age': 'Edad',
    'avatar.model': 'Modelo',
    'avatar.onboarded': 'Incorporado',
    'avatar.processing': 'Procesamiento',
    'avatar.avatar': 'Avatar',
    'avatar.description': 'Descripción',
    'avatar.listTitle': 'Asistentes',
    'avatar.noAvatars': 'No se encontraron asistentes',
    'avatar.addAvatar': 'Agregar Asistente',
    'avatar.searchPlaceholder': 'Buscar asistente...',
    'avatar.listView': 'Vista de Lista',
    'avatar.gridView': 'Vista de Cuadrícula',
    // Avatar form knowledge section
    // Avatar form page
    // Configuración de webhooks
    // Definiciones de webhooks
    // Ejemplos de carga útil de webhooks
    // Tipos de eventos de webhooks
    // Acciones de conocimiento
    'knowledge.edit': 'Editar Conocimiento',
    // Intervalos cron de webhooks
    // Configuración del léxico
    'apiTool.requestSent': 'Solicitud enviada',
    'apiTool.requestFailed': 'Solicitud fallida',
    'apiTool.collectingData': 'Recopilando datos...',
    'apiTool.response': 'Respuesta',
    'apiTool.noData': 'Sin datos de solicitud API',
    'tools.productCard': 'Tarjetas de Producto',
    'avatar.creator': 'Creador',
    'avatar.voiceAgent': 'Agente de Voz',
    'avatar.common': 'Avatar Común',
    'avatar.active': 'Activo',
    'avatar.cantEditCommon': 'No se pueden editar avatares comunes. Solo los super administradores pueden editar avatares comunes.',
    'avatar.cantDeleteCommon': 'No se pueden eliminar avatares comunes. Solo los super administradores pueden eliminar avatares comunes.',
    // Avatar tooltips
    // Avatar knowledge management
    // Avatar preview page
    // Style List Columns
    'style.name': 'Nombre',
    'style.description': 'Descripción',
    'style.prompt': 'Prompt',
    'style.common': 'Estilo Común',
    'style.active': 'Activo',
    'style.style': 'Estilo',
    // Style list page
    'style.listTitle': 'Estilos de Escritura',
    'style.addStyle': 'Agregar Estilo de Escritura',
    'style.searchPlaceholder': 'Buscar estilos...',
    // Style form page
    'style.updated': 'actualizado',
    'style.created': 'creado',
    'style.update': 'actualizar',
    'style.create': 'crear',
    // Paquetes de Precios List Columns
    'accountGrade.name': 'Nombre',
    'accountGrade.description': 'Descripción',
    'accountGrade.advancedPrompts': 'Prompts Avanzados',
    'accountGrade.promptAssist': 'Asistente de Prompts',
    'accountGrade.maxAvatars': 'Máx. Avatares',
    'accountGrade.maxUsers': 'Máx. Usuarios',
    'accountGrade.maxProjectsCount': 'Máx. Proyectos',
    'accountGrade.maxKnowledgeEntries': 'Máx. Conocimiento',
    'accountGrade.antiHallucination': 'Anti-Alucinación',
    'accountGrade.advancedReports': 'Reportes Avanzados',
    'accountGrade.chatThreadSharing': 'Compartir Hilos de Chat',
    'accountGrade.customBranding': 'Marca Personalizada',
    'accountGrade.widgets': 'Widgets',
    'accountGrade.customAiModels': 'Modelos AI Personalizados',
    'accountGrade.voiceAgent': 'Agente de Voz',
    'accountGrade.writingStyles': 'Estilos de Escritura',
    'accountGrade.price': 'Precio Mensual',
    'accountGrade.yearlyPrice': 'Precio Anual',
    'accountGrade.creditsPerMonth': 'Créditos por Mes',
    'accountGrade.active': 'Activo',
    'accountGrade.order': 'Orden',
    // Paquetes de Precios list page
    'accountGrade.listTitle': 'Paquetes de Precios',
    'accountGrade.noAccountGrades': 'No se encontraron paquetes de precios',
    'accountGrade.noResults': 'No se encontraron paquetes de precios',
    'accountGrade.addAccountGrade': 'Agregar Paquete de Precios',
    'accountGrade.add': 'Agregar Paquete de Precios',
    'accountGrade.createTitle': 'Crear Paquete de Precios',
    'accountGrade.searchPlaceholder': 'Buscar paquete de precios...',
    // Paquetes de Precios form page
    // Paquetes de Precios sections
    'accountGrade.previewTitle': 'Vista Previa del Paquete de Precios',
    'accountGrade.basicInfo': 'Información Básica',
    'accountGrade.features': 'Características',
    'accountGrade.status': 'Estado',
    'accountGrade.limits': 'Límites',
    'accountGrade.unlimited': 'Ilimitado',
    // Account limits and restrictions
    'limits.noAccountGrade': 'No se encontró plan de cuenta. Por favor contacte al soporte.',
    'limits.featureDisabled': 'Esta función está deshabilitada para su plan de cuenta.',
    // Voice chat errors
    // Email translations
    // Account upgrade emails
    // Payment success emails
    // Payment failed emails
    // Common payment fields
    // Registration completion
    // Password Reset Page
    // Password Reset Confirm Page
    // Paquetes de Precios preview page
    'chatDemo.title': 'Demo del Sistema de Chat',
    'chatDemo.intro': 'Se ha implementado un sistema completo de historial de conversaciones.',
    'chatDemo.featuresTitle': 'Características implementadas:',
    'chatDemo.openChat': 'Abrir Sistema de Chat',
    'chatDemo.implementationTitle': 'Detalles de implementación:',
    'chatDemo.backendModels': 'Modelos backend:',
    'chatDemo.apiEndpoints': 'Endpoints API:',
    'chatDemo.frontendComponents': 'Componentes frontend:',
    'home.dashboardArea': 'ÁREA DE PANEL',
    'form.label': 'Etiqueta',
    'form.value': 'Valor',
    'form.required': 'Requerido',
    'form.optional': 'Opcional',
    'login.usernameLabel': 'Usuario/Email',
    'login.passwordLabel': 'Contraseña',
    'login.forgotPassword': '¿Olvidaste tu contraseña?',
    'login.submit': 'Iniciar sesión',
    'register.nameLabel': 'Nombre',
    'register.lastNameLabel': 'Apellido',
    'register.usernameLabel': 'Usuario',
    'register.emailLabel': 'Correo electrónico',
    'register.passwordLabel': 'Contraseña',
    'register.repeatPasswordLabel': 'Repetir Contraseña',
    'register.submit': 'Registrarse',
    // Route translations
    'route.dashboard': 'Panel',
    'route.companyManagement': 'Gestión de Empresas',
    'route.settings': 'Configuraciones',
    'route.register': 'Registro',
    'route.profile': 'Perfil',
    'route.team': 'Equipo',
    'route.assistants': 'Asistentes',
    // Style routes
    'route.styles': 'Estilos de Escritura',
    'route.conversations': 'Conversaciones',
    'route.conversationList': 'Conversaciones',
    'route.conversationPreview': 'Vista Previa de Conversación',
    'tutorial.noDescription': 'No hay descripción disponible',
    'tutorial.steps': 'pasos',
    'tutorial.sections': 'secciones',
    'tutorial.noTasks': 'No hay tareas disponibles para esta sección',
    'tutorial.created': 'Tutorial creado exitosamente',
    'tutorial.updated': 'Tutorial actualizado exitosamente',
    'tutorial.saveFailed': 'Error al guardar el tutorial',
    'tutorial.loadFailed': 'Error al cargar el tutorial',
    'tutorial.loadListFailed': 'Error al cargar los tutoriales',
    'tutorial.deleteFailed': 'Error al eliminar el tutorial',
    // Form-related translations
    // Error messages
    // Additional validation messages
    'botTest.title': 'Prueba de Bot',
    'botTest.name': 'Nombre de la Prueba',
    'botTest.date': 'Fecha',
    'botTest.testDate': 'Fecha de Prueba',
    'botTest.description': 'Descripción',
    'botTest.testers': 'Probadores',
    'botTest.targets': 'Objetivos',
    'botTest.messages': 'mensajes',
    'botTest.noTesters': 'No hay probadores disponibles para ejecutar',
    'botTest.addTester': 'Agregar Probador',
    'botTest.addTarget': 'Agregar Objetivo',
    'botTest.model': 'Modelo',
    // Bot Test Preview
    // Bot Test Preview Tabs
    // Bot Test Results
    // Bot Test Results
    'route.ai': 'Chat IA',
    'ai-assist.header': 'Asistente de IA',
    'ai-assist.minimize': 'Minimizar',
    'ai-assist.expand': 'Expandir',
    'ai-assist.info': 'El asistente de IA analizará tus prompts y conversaciones y proporcionará sugerencias para ayudar a obtener mejores resultados. Puedes desactivarlo en la configuración del chat en la esquina inferior derecha del área de entrada del chat',
    'ai-assist.no-entries': 'Inicia una conversación para activar la ayuda del asistente de IA',
    'modelSelect.instruction': 'Elige tu avatar o modelo de IA con el que quieres hablar',
    'modelSelect.knowledgeCreatingInProgress': 'Creando entrada de base de conocimiento en progreso...',
    // AI Suggestions Component
    // Autocomplete Triggers Component
    // AI Assist Component
    // Model Select Component
    'modelSelect.models': 'Modelos',
    'modelSelect.avatars': 'Avatares',
    'modelSelect.liveChats': 'Chats en Vivo',
    'modelSelect.voiceModels': 'Modelos de Voz',
    // Traducciones de conversaciones
    'conversation.demo': 'Agente de Voz',
    'conversation.agent': 'Agente',
    'conversation.connected': 'Conectado',
    'conversation.disconnected': 'Desconectado',
    'conversation.connecting': 'Conectando...',
    'conversation.voice': 'Voz',
    'conversation.you': 'Tú',
    'conversation.send': 'Enviar',
    'conversation_agent.first_word': '¡Hola! ¿Cómo puedo ayudarte hoy?',
    'conversation.volume': 'Volumen',
    'conversation.debug': 'Información de Debug',
    'conversation.language': 'Idioma',
    'conversation.messages': 'Mensajes',
    'conversation.started': '¡Conversación iniciada exitosamente!',
    'conversation.ended': 'Conversación finalizada.',
    'conversation.error': 'Ocurrió un error durante la conversación.',
    'conversation.start': 'Iniciar Conversación',
    'conversation.end': 'Terminar Conversación',
    'recording.start': 'Iniciar Grabación',
    'recording.stop': 'Detener Grabación',
    'message.used_tools': 'Herramientas Utilizadas',
    'conversations.title': 'Conversaciones',
    'conversations.loading': 'Cargando conversaciones...',
    'conversations.retry': 'Reintentar',
    'conversations.empty': 'No se encontraron conversaciones',
    'conversations.chat_history': 'Historial de Chat',
    'conversations.no_conversations_yet': 'Aún no hay conversaciones',
    'conversations.no_messages_yet': 'Aún no hay mensajes',
    'conversations.loading_more': 'Cargando más...',
    'conversations.no_more_conversations': 'No hay más conversaciones',
    'conversations.avatar': 'Avatar',
    'conversations.new_chat': 'Nuevo Hilo',
    // Acciones comunes
    'common.create': 'Crear',
    'common.update': 'Actualizar',
    'common.cancel': 'Cancelar',
    'common.close': 'Cerrar',
    'common.back': 'Volver',
    'common.clear': 'Limpiar',
    'common.moveUp': 'Mover arriba',
    'common.moveDown': 'Mover abajo',
    'common.delete': 'Eliminar',
    'common.optional': '(Opcional)',
    'common.none': 'Ninguno',
    'common.pay': 'Pagar',
    'common.loading': 'Cargando...',
    'common.showing': 'Mostrando',
    'common.to': 'a',
    'common.of': 'de',
    'common.next': 'Siguiente',
    'common.previous': 'Anterior',
    'common.apply': 'Aplicar',
    'common.results': 'resultados',
    'common.hide': 'Ocultar',
    // Gestión de cuenta
    // Niveles de cuenta
    // Rutas de conocimiento
    // Traducciones de conocimiento
    'knowledge.create': 'Crear conocimiento',
    'knowledge.title': 'Título',
    'knowledge.description': 'Descripción',
    'knowledge.content': 'Contenido',
    'knowledge.file': 'Archivo',
    'knowledge.tags': 'Etiquetas',
    'knowledge.project': 'Proyecto',
    'knowledge.no_project': 'Sin proyecto',
    'knowledge.active': 'Activo',
    'project.manage': 'Gestionar proyectos',
    'project.none': 'Sin proyecto',
    'knowledge.native': 'Conocimiento Nativo',
    'knowledge.creator': 'Creador',
    'knowledge.ragStatus': 'Estado RAG',
    'knowledge.assigned': 'Asignado',
    'knowledge.createdAt': 'Creado el',
    // RAG Status Values
    'knowledge.reindex': 'Re-indexar',
    'knowledge.reindexingStarted': 'La re-indexación ha comenzado',
    // Traducciones del formulario de conocimiento
    // Traducciones de carga masiva de conocimiento
    // Google Drive bulk upload
    // Google Drive bulk upload info
    // Knowledge preview
    'knowledge.preview': 'Vista Previa del Conocimiento',
    // Knowledge preview sections
    // Knowledge preview content type labels
    // Knowledge preview RAG status labels
    // Knowledge preview active status
    // Knowledge preview usage
    // Traducciones de grupos de conocimiento
    // Project form
    // Project general
    'project.name': 'Nombre del proyecto',
    'project.description': 'Descripción',
    'project.color': 'Color',
    'project.icon': 'Icono',
    'project.isActive': 'Activo',
    'project.preview': 'Vista previa',
    'project.list': 'Proyectos',
    'project.create': 'Agregar proyecto',
    'project.edit': 'Editar proyecto',
    'project.creator': 'Creador',
    // Traducciones para el componente de carga de archivos
    'file.ext': 'tipo de archivo',
    'file.size': 'tamaño de archivo',
    // Chat component translations
    // Page title for Chat page
    // CodeViewerComponent translations
    'code-viewer.show_code': 'Mostrar código',
    'code-viewer.hide_code': 'Ocultar código',
    'code-viewer.writing_code': 'Escribiendo código',
    // Mensajes popup
    'popup.error': 'Error',
    'popup.alert': 'Alerta',
    'popup.confirm': 'Confirmar',
    'popup.ok': 'OK',
    'popup.yes': 'Sí',
    'popup.no': 'No',
    // LLM Trainer
    'trainer.title': 'Entrenador de Modelo LLM',
    'trainer.listTitle': 'Lista de Entrenadores',
    'trainer.addJob': 'Agregar Trabajo',
    // Componente de Carga
    // Entrada Manual
    // PDF Processing
    // Componente de Configuración
    // Componente de Progreso
    // Componente de Resultados
    // Componente de Instrucciones
    "training_jobs.list": "Lista de trabajos de entrenamiento",
    "trainer.jobId": "ID de Trabajo",
    "trainer.modelName": "Nombre del Modelo",
    "trainer.trainingType": "Tipo de Entrenamiento",
    "trainer.status": "Estado",
    "trainer.createdAt": "Creado el",
    "trainer.updatedAt": "Actualizado el",
    // Traducciones de ramas
    'route.branches': 'Ramas',
    'branch.name': 'Nombre',
    'branch.description': 'Descripción',
    'branch.color': 'Color',
    'branch.create': 'Crear Rama',
    // Branch form page
    'branch.form.error.load_failed': "Error al cargar la rama",
    'branch.form.error.action_failed': "Acción fallida",
    'branch.form.error.general_error': "Ocurrió un error",
    'branch.form.action.updated': "actualizada",
    'branch.form.action.created': "creada",
    'branch.form.action.update': "actualizar",
    'branch.form.action.create': "crear",
    'branch.form.success.updated': "Rama actualizada con éxito",
    'branch.form.success.created': "Rama creada con éxito",
    'branch.form.success.action_completed': "Acción completada",
    // Traducciones de profesiones
    'route.professions': 'Profesiones',
    'profession.name': 'Nombre',
    'profession.description': 'Descripción',
    'profession.branch': 'Rama',
    'profession.create': 'Crear Profesión',
    'profession.common': 'Común',
    'profession.creator': 'Creador',
    // Step translations
    'route.steps': 'Pasos',
    'step.title': 'Título',
    'step.description': 'Descripción',
    'step.order': 'Orden',
    'step.isShared': 'Compartido',
    'step.profession': 'Profesión',
    'step.create': 'Crear Paso',
    // Step form page
    // Question translations
    'route.questions': 'Preguntas',
    'question.title': 'Título',
    'question.description': 'Descripción',
    'question.type': 'Tipo',
    'question.required': 'Requerido',
    'question.order': 'Orden',
    'question.step': 'Paso',
    'question.create': 'Crear Pregunta',
    // Question form (question manager)
    // Question types
    // Onboarding translations
    'route.onboardings': 'Onboarding',
    // Onboarding intro
    'onboarding.avatar': 'Avatar',
    'onboarding.profession': 'Profesión',
    'onboarding.status': 'Estado',
    'onboarding.currentStep': 'Paso Actual',
    'onboarding.createdAt': 'Creado',
    'onboarding.create': 'Iniciar Onboarding',
    // Onboarding Wizard translations
    // Onboarding Component
    'onboarding.title': 'Onboarding',
    'onboarding.loading': 'Cargando...',
    // AI Onboarding page content
    // FAQ Section
    // Voice descriptions
    // Onboarding Records (for user-list component)
    'knowledge': 'conocimiento',
    // Additional onboarding translations
    'onboarding.filter': 'Filtrar',
    'onboarding.progress': 'Progreso',
    'onboarding.createdBy': 'Creado por',
    'pagination.previous': 'Anterior',
    'pagination.next': 'Siguiente',
    'actions': 'Acciones',
    'view': 'Ver',
    'edit': 'Editar',
    'delete': 'Eliminar',
    'loading': 'Cargando...',
    // Onboarding view page
    // Onboarding pick page
    // Onboarding errors
    // Onboarding success messages
    // Additional onboarding fields
    'onboarding.fields_completed': 'campos completados',
    // Missing login/register keys not in the main section
    // Registration Complete page
    // Account Activation page
    // Settings translations
    'settings.saveButton': 'Guardar Configuración',
    'settings.savedSuccessfully': 'Configuración guardada exitosamente',
    'settings.failedToSave': 'Error al guardar la configuración',
    'settings.failedToLoad': 'Error al cargar la configuración',
    // Settings Tabs
    // General Settings - Chat Learning
    // RAG Settings
    // RAG Settings Component
    // Knowledge Form RAG Override
    // Credit Settings
    // RAG File Operations
    // RAG Indexing Settings
    // RAG Search Settings
    // Google Drive Settings
    // Google Drive File Picker
    // Status indicators
    // Google Drive Status
    // Setup Instructions
    // How it works
    // Connected state
    // Resource translations
    'resource.active': 'Activo',
    // Generated Image Component
    'gen-image.noData': 'No se proporcionaron datos de imagen',
    'gen-image.invalidData': 'Formato de datos de imagen inválido',
    'gen-image.loadError': 'Error al cargar la imagen',
    'gen-image.loading': 'Cargando imagen...',
    'gen-image.altText': 'Imagen generada',
    'gen-image.download': 'Descargar',
    'gen-image.copyToClipboard': 'Copiar al portapapeles',
    // File Card Component
    'file-card.errorLoading': 'Error al cargar el archivo',
    'file-card.unknownFile': 'Archivo desconocido',
    'file-card.unknownSize': 'Tamaño desconocido',
    'file-card.download': 'Descargar',
    'file-card.addToKdb': 'Agregar a la Base de Conocimiento',
    'file-card.videoNotSupported': 'Su navegador no admite la etiqueta de video.',
    'file-card.zoomHint': 'haz clic para ampliar',
    'file-card.zoom': 'Ampliar',
    'file-card.close': 'Cerrar',
    // Reports routes
    // Reports and Cost Analytics
    'reports.totalCost': 'Costo Total',
    'reports.totalMessages': 'Mensajes Totales',
    'reports.avgCostPerMessage': 'Costo Promedio/Mensaje',
    'reports.totalTokens': 'Tokens Totales',
    'reports.filters': 'Filtros',
    'reports.startDate': 'Fecha de Inicio',
    'reports.endDate': 'Fecha de Fin',
    'reports.minCost': 'Costo Mínimo',
    'reports.maxCost': 'Costo Máximo',
    'reports.userName': 'Nombre de Usuario',
    'reports.companyName': 'Nombre de Empresa',
    'reports.userNamePlaceholder': 'Filtrar por nombre de usuario...',
    'reports.companyNamePlaceholder': 'Filtrar por nombre de empresa...',
    'reports.avatarNamePlaceholder': 'Filtrar por nombre de avatar...',
    'reports.date': 'Fecha',
    'reports.promptTokens': 'Tokens de Prompt',
    'reports.completionTokens': 'Tokens de Completación',
    'reports.cost': 'Costo',
    'reports.cost_type': 'Tipo de Consulta',
    'reports.company': 'Empresa',
    'reports.upstreamCost': 'Costo Upstream',
    'reports.reasoningTokens': 'Tokens de Razonamiento',
    'reports.cachedTokens': 'Tokens en Caché',
    'reports.noData': 'No hay datos de costo disponibles',
    'reports.noDataDescription': 'No se encontraron datos de costo de uso para los criterios seleccionados.',
    'reports.failedToLoad': 'Error al cargar datos de costo',
    'reports.loadingError': 'Error al cargar datos de costo',
    'reports.user': 'Usuario',
    'reports.costTrends': 'Tendencias de Costos y Tokens',
    'reports.showChart': 'Mostrar Gráfico',
    'reports.tokens': 'Tokens',
    'report.usage_cost_data': 'Datos de Costos de Uso',
    'reports.userSummary': 'Estadísticas de Resumen de Usuarios',
    'reports.messageCount': 'Mensajes',
    'reports.avatarUsage': 'Estadísticas de Uso de Avatar',
    'reports.avgTokensPerMessage': 'Tokens Promedio/Mensaje',
    'reports.firstUsage': 'Primer Uso',
    'reports.lastUsage': 'Último Uso',
    // Chat Settings
    // Chat Config
    // Config Tooltips
    // Knowledge Database Tooltips
    'kdb.fullscan_tooltip': 'El escaneo completo del documento pondrá todo el archivo en el prompt, resultando en respuestas más costosas y largas',
    // Share Conversation
    // AI Assistant Context
    'context.userMessages': 'mensajes del usuario',
    'context.assistantMessages': 'mensajes del asistente',
    'context.activeEntries': 'entradas activas',
    'context.summary': 'Contexto',
    'context.empty': 'No hay contexto disponible',
    'context.validationError': 'Error de validación de contexto',
    // Reportes
    'and': 'y',
    // ACL Table
    // ACL Resource Descriptions
    'acl_resource_desc.company': 'Gestionar configuración e información de la empresa',
    'acl_resource_desc.user': 'Gestionar cuentas de usuario y perfiles',
    'acl_resource_desc.user_group': 'Gestionar grupos de usuarios y sus permisos',
    'acl_resource_desc.settings_general': 'Acceso a configuraciones generales de la aplicación',
    'acl_resource_desc.settings_access': 'Gestionar control de acceso y configuraciones de seguridad',
    'acl_resource_desc.settings_styles': 'Gestionar estilos de escritura y plantillas',
    'acl_resource_desc.avatar': 'Crear y gestionar avatares de IA y asistentes',
    'acl_resource_desc.ai': 'Acceso a modelos de IA y configuraciones',
    'acl_resource_desc.knowledge': 'Gestionar base de conocimientos y recursos de información',
    'acl_resource_desc.project': 'Crear y gestionar proyectos y flujos de trabajo',
    'acl_resource_desc.onboarding': 'Gestionar procesos de incorporación de usuarios y plantillas',
    'acl_resource_desc.reports': 'Generar y ver informes del sistema y análisis',
    // ACL Action Descriptions
    'acl_action_desc.read': 'Ver y acceder a información sin realizar cambios',
    'acl_action_desc.write': 'Crear, editar y modificar contenido y configuraciones',
    'acl_action_desc.delete': 'Eliminar y borrar permanentemente elementos del sistema',
    // V-Select Component
    'v-select.createNew': 'Crear nuevo',
    'v-select.noOptions': 'No hay opciones disponibles',
    // Keyboard shortcuts
    'shortcuts.title': 'Atajos de Teclado',
    'shortcuts.tooltip-text': 'Ver atajos de teclado disponibles',
    // Password Reset
    // Password Reset Confirm
    // Routes
    'route.passwordReset': 'Restablecer Contraseña',
    'route.passwordResetConfirm': 'Restablecer Contraseña',
    'route.registerComplete': 'Registro Completado',
    'route.activateAccount': 'Activar Cuenta',
    // Currency
    // Navigation
    'nav.credits': 'Créditos',
    // Tools
    'tools.toolLabel': 'Herramienta',
    'tools.activeTools': 'Herramientas Activas',
    'tools.expandAll': 'Expandir Todo',
    'tools.collapseAll': 'Contraer Todo',
    'tools.unknownTool': 'Herramienta desconocida',
    'tools.noActiveTools': 'No hay herramientas activas',
    'tools.webSearch': 'Búsqueda Web',
    'tools.rag': 'Base de Conocimiento',
    'webSearch.searching': 'Buscando en la web',
    'webSearch.toolData': 'Datos de Búsqueda Web',
    'webSearch.searchingFor': 'Buscando',
    'webSearch.resultsFound': 'resultados encontrados',
    'webSearch.noResultsFound': 'No se encontraron resultados',
    'webSearch.tryDifferentQuery': 'Intenta con una consulta diferente',
    'rag.searchingKnowledge': 'Buscando en la base de conocimiento',
    'rag.open_knowledge_preview': 'Abrir vista previa de conocimiento',
    'rag.openInKnowledgeBase': 'Vista Previa',
    'rag.noFilesIncluded': 'No se incluyen archivos',
    'rag.sources_used': 'Fuentes utilizadas',
    'rag.sources': 'Fuentes',
    'rag.open_sources': 'Ver fuentes',
    // Product Cards
    'productCard.toolData': 'Tarjetas de Producto',
    'productCard.productList': 'Lista de Productos',
    'productCard.singleProduct': 'Producto Único',
    'productCard.product': 'producto',
    'productCard.products': 'productos',
    'productCard.grossPrice': 'Precio Bruto',
    'productCard.netPrice': 'Precio Neto',
    'productCard.vat': 'IVA',
    'productCard.category': 'Categoría',
    'productCard.viewProduct': 'Ver Producto',
    'productCard.noProducts': 'No se encontraron productos',
    'productCard.trySearching': 'Intenta buscar productos',
    // Product Compare Tool
    'productCompare.domain': 'Dominio',
    'productCompare.comparing': 'Comparando',
    'productCompare.searchQuery': 'Consulta de búsqueda',
    'productCompare.noResults': 'No se encontraron resultados de comparación',
    // Detect Contact Data Tool
    'detectContactData.phoneNumbers': 'Números de teléfono',
    'detectContactData.emails': 'Correos electrónicos',
    'detectContactData.addresses': 'Direcciones',
    'detectContactData.names': 'Nombres',
    'detectContactData.companies': 'Empresas',
    'detectContactData.socialMedia': 'Redes sociales',
    'detectContactData.websites': 'Sitios web',
    'detectContactData.other': 'Otros',
    'detectContactData.noData': 'No se detectaron datos de contacto',
    // Detect Tasks Tool
    'detectTasks.notes': 'Notas',
    'detectTasks.noTasks': 'No se detectaron tareas',
    // Offer Creator Tool
    'offerCreator.companyName': 'Nombre de la empresa',
    'offerCreator.firstName': 'Nombre',
    'offerCreator.lastName': 'Apellido',
    'offerCreator.email': 'Correo electrónico',
    'offerCreator.phone': 'Teléfono',
    'offerCreator.vatPayer': 'Contribuyente de IVA',
    'offerCreator.employeesNumber': 'Número de empleados',
    'offerCreator.businessActivity': 'Actividad empresarial',
    'offerCreator.taxationType': 'Tipo de tributación',
    'offerCreator.documentsNumber': 'Número de documentos',
    'offerCreator.packageId': 'Paquete',
    'offerCreator.additionalInfo': 'Información adicional',
    'offerCreator.formSent': 'Formulario enviado',
    'offerCreator.noData': 'No se recopilaron datos de oferta',
    // Quick Offer Tool
    'quickOffer.availableOptions': 'Opciones disponibles',
    'quickOffer.formSent': 'Formulario enviado',
    'quickOffer.noFields': 'Sin campos de formulario',
    // Send Contact Form Tool
    'sendContactForm.name': 'Nombre',
    'sendContactForm.email': 'Correo electrónico',
    'sendContactForm.phone': 'Teléfono',
    'sendContactForm.message': 'Mensaje',
    'sendContactForm.formSent': 'Formulario de contacto enviado',
    'sendContactForm.noData': 'Sin datos del formulario de contacto',
    // Conversation Tags Tool
    'convoTags.noTags': 'No se detectaron etiquetas',
    // Gallery Tags Tool
    'galleryTags.noTags': 'No se detectaron etiquetas de galería',
    // Ask For Voucher Tool
    'askForVoucher.detected': 'Solicitud de cupón detectada',
    'askForVoucher.notDetected': 'No se detectó solicitud de cupón',
    // Dynamic Listings Tool
    'dynamicListings.listingsSignalled': 'listados señalados',
    'dynamicListings.allListings': 'Todos los listados señalados',
    // Product API Search Tool
    'productAPISearch.searchQuery': 'Consulta de búsqueda',
    'productAPISearch.totalResults': 'resultados totales',
    'productAPISearch.subcategories': 'subcategorías',
    'productAPISearch.noResults': 'No se encontraron resultados',
    // Google Drive
    // Knowledge Bulk Upload
    // DB Logs page
    'dblogs.title': 'Registros de auditoría de BD',
    'dblogs.show': 'Mostrar',
    'dblogs.hide': 'Ocultar',
    'dblogs.empty': 'No se encontraron entradas de registro.',
    // DB model collection names
    'model.user': 'Usuario',
    'model.user_group': 'Grupo de usuarios',
    'model.api_keys': 'Claves API',
    'model.acl_policy': 'Política ACL',
    'model.company': 'Empresa',
    'model.conversation': 'Conversación',
    'model.message': 'Mensaje',
    'model.avatar': 'Avatar',
    'model.user_avatar': 'Avatar de usuario',
    'model.knowledge': 'Conocimiento',
    'model.knowledgeGroup': 'Grupo de conocimiento',
    'model.file': 'Archivo',
    'model.training_job': 'Trabajo de entrenamiento',
    'model.avatar_knowledge': 'Conocimiento del avatar',
    'model.avatar_instruction': 'Instrucción del avatar',
    'model.avatar_instruction_version': 'Versión de instrucción del avatar',
    'model.profession_knowledge': 'Conocimiento profesional',
    'model.profession_step': 'Paso de profesión',
    'model.custom_models': 'Modelo personalizado',
    'model.embeddings': 'Incrustación',
    'model.branch': 'Rama',
    'model.profession': 'Profesión',
    'model.step': 'Paso',
    'model.step_profession': 'Paso de profesión',
    'model.onboarding': 'Incorporación',
    'model.db_logs': 'Registro de BD',
    'model.question': 'Pregunta',
    'model.answer': 'Respuesta',
    'model.settings': 'Configuración',
    'model.usage_cost': 'Costo de uso',
    'model.knowledge_elevenlabs_mappings': 'Mapeo ElevenLabs de conocimiento',
    'model.front_sync': 'Sincronización de frontend',
    'model.favorite_conversation': 'Conversación favorita',
    'model.style': 'Estilo',
    'model.slotData': 'Datos de ranura',
    'model.payments': 'Pago',
    'model.account_balance': 'Saldo de cuenta',
    'model.accountGrade': 'Nivel de cuenta',
    'model.currencyRate': 'Tipo de cambio',
    'model.test_result': 'Resultado de prueba',
    'model.bot_test': 'Prueba de bot',
    'model.bot_test_tester': 'Tester de bot',
    'model.bot_test_target': 'Objetivo de prueba de bot',
    'model.tutorial': 'Tutorial',
    'model.tutorial_step': 'Paso de tutorial',
    'model.tutorial_section': 'Sección de tutorial',
    'model.tutorial_section_knowledge': 'Conocimiento de sección de tutorial',
    'model.tutorial_section_todo': 'Todo de sección de tutorial',
    'model.tutorial_participants': 'Participante de tutorial',
    'model.todo': 'Tarea',
    'model.todo_item': 'Elemento de tarea',
    'model.todo_item_value': 'Valor de elemento de tarea',
    'model.cache': 'Caché',
    'model.api_tool_definition': 'Definición de herramienta API',
    // DB operation names
    // WhatsApp settings
    "route.settings.comms": "Comunicaciones",
    "route.settings.comms.create": "Crear comunicación",
    "route.settings.comms.edit": "Editar comunicación",
    "route.settings.comms.manage": "Gestionar comunicación",
    "route.settings.comms.group": "Detalles del grupo",
    "route.settings.comms.group.create": "Crear grupo",
    "route.settings.comms.dm": "Contacto de mensaje directo",
    'socialMediaPlan.title': 'Content Studio', 'socialMediaPlan.failedToLoad': 'Error al cargar publicaciones', 'socialMediaPlan.newPost': 'Nueva publicación', 'socialMediaPlan.library': 'Biblioteca', 'socialMediaPlan.search': 'Buscar...', 'socialMediaPlan.edit': 'Editar', "socialMediaPlan.schedule.action": '¿Qué sigue?', 'socialMediaPlan.back': 'Atrás', 'socialMediaPlan.next': 'Siguiente', 'socialMediaPlan.cancel': 'Cancelar', 'socialMediaPlan.save': 'Confirmar y guardar', 'socialMediaPlan.close': 'Cerrar',
    'whatsapp.loginFailed': 'Error en el inicio de sesión de WhatsApp.',
    'whatsapp.logoutSuccess': 'Sesión de WhatsApp cerrada correctamente.',
    'whatsapp.logoutFailed': 'Error al cerrar sesión de WhatsApp.',
    'whatsapp.failedToLoad': 'Error al cargar el estado de WhatsApp.',
    'whatsapp.entityIdRequired': 'Se requiere ID de entidad.',
    'whatsapp.phoneRequired': 'Se requiere número de teléfono.',
    'whatsapp.settingsSaved': 'Configuración de WhatsApp guardada correctamente.',
    'whatsapp.settingsSaveFailed': 'Error al guardar la configuración de WhatsApp.',
    'whatsapp.agentStarted': 'Agente de WhatsApp iniciado correctamente.',
    'whatsapp.agentStartFailed': 'Error al iniciar el agente de WhatsApp.',
    'whatsapp.agentStopped': 'Agente de WhatsApp detenido correctamente.',
    'whatsapp.agentStopFailed': 'Error al detener el agente de WhatsApp.',
    // WhatsApp group
    // WhatsApp track logs
    // Activity panels
    // WhatsApp tabs
    // Comms Threads
    // WhatsApp email
    // WhatsApp direct messages
    // Email Reporting (POP3) Settings
    'whatsapp.pop3SettingsSaved': 'Configuración de correo guardada exitosamente.',
    'whatsapp.pop3SettingsSaveFailed': 'No se pudo guardar la configuración de correo.',
    // WhatsApp DM detail page
    // ACL translations
    ...es_1.aclTranslationsEs
};
